var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageGallery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59922 6.00002C2.9627 6.00002 2.35225 6.25288 1.90216 6.70297C1.45208 7.15306 1.19922 7.7635 1.19922 8.40002V20.4C1.19922 21.0365 1.45208 21.647 1.90216 22.0971C2.35225 22.5472 2.9627 22.8 3.59922 22.8H20.3992C21.0357 22.8 21.6462 22.5472 22.0963 22.0971C22.5464 21.647 22.7992 21.0365 22.7992 20.4V8.40002C22.7992 7.7635 22.5464 7.15306 22.0963 6.70297C21.6462 6.25288 21.0357 6.00002 20.3992 6.00002H3.59922ZM3.59922 19.2L7.79922 13.8L10.7992 17.4L14.9992 12L20.3992 19.2H3.59922ZM19.1992 2.40002C19.8357 2.40002 20.4462 2.65288 20.8963 3.10297C21.3464 3.55306 21.5992 4.1635 21.5992 4.80002H2.39922C2.39922 4.1635 2.65208 3.55306 3.10216 3.10297C3.55225 2.65288 4.1627 2.40002 4.79922 2.40002H19.1992Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageGallery);
export default __webpack_public_path__ + "static/media/imageGallery.c30da82947547ce597decf679ee72d3c.svg";
export { ForwardRef as ReactComponent };